import React from 'react';
import { Step } from '../SteppedForm';
import { Grid, Typography, Divider, Button } from '@material-ui/core';

const faqs = {};

let questions = {};

let currentState;
const inStates = (states) => states.indexOf(currentState) >= 0;

// updated
questions.Why_13cabs = () => (
  <div className="question">
    <div className="title">Why 13cabs?</div>
    <div className="body">
      <Typography className="text">
        13cabs is Australia’s leading personal transport provider with a national fleet of branded
        vehicles. We also operate the Silver Service brand of Taxis nationally. You may apply to be
        an Operator for 13cabs and Silver Service brands on this form.
      </Typography>
      <Typography className="text">
        13cabs has access to exclusive account bookings. These bookings are made by many businesses
        and government organisations who hold Cabcharge accounts. Payment for these trips is made
        directly into your 13cabs Operator Account.
      </Typography>
      <div className="list-title">Other benefits include:</div>
      <ul>
        <li className="list-item">24/7 support</li>
        <li className="list-item">
          CabAccess reporting tool for your vehicles and Professional Drivers
        </li>
        {!inStates(['wa']) ? (
          <li className="list-item">Taxi Momentum to check your account activity</li>
        ) : (
          ''
        )}
        <li className="list-item">vehicle inspections</li>
        {!inStates(['sa']) ? (
          <li className="list-item">multiple TAXITECH workshops for vehicle support</li>
        ) : (
          ''
        )}
        {inStates(['qld', 'sa', 'wa']) ? (
          <li className="list-item">access to fuel benefits</li>
        ) : (
          ''
        )}
        <li className="list-item">national marketing programs</li>
        <li className="list-item">advanced technology products, including MyDriver</li>
      </ul>
    </div>
    <Divider light />
  </div>
);

// updated
questions.What_do_I_need_to_do_before_becoming_a_13cabs_silver_service_Operator = () => (
  <div className="question">
    <div className="title">
      What do I need to do before becoming a 13cabs or Silver Service Operator?
    </div>
    <div className="body">
      {inStates(['vic']) ? (
        <Typography className="text">
          Only registered commercial passenger vehicles can legally provide commercial passenger
          vehicle services in Victoria. If you want to use your vehicle to provide Taxi vehicle
          services, you must register your vehicle with CPVV.
        </Typography>
      ) : inStates(['wa']) ? (
        <Typography className="text">
          Only registered commercial passenger vehicles can legally provide commercial passenger
          vehicle services in Western Australia. If you want to use your vehicle to provide Taxi
          vehicle services, you must register your vehicle with DoT.
        </Typography>
      ) : inStates(['nsw']) ? (
        <Typography className="text">
          Only registered commercial passenger vehicles can legally provide commercial passenger
          vehicle services in New South Wales. If you want to use your vehicle to provide Taxi
          vehicle services, you must register your vehicle with{' '}
          <a
            href="https://www.service.nsw.gov.au/transaction/application-passenger-transport-licence-code"
            target="_blank"
            rel="noopener noreferrer">
            Services NSW
          </a>
        </Typography>
      ) : inStates(['qld']) ? (
        <Typography className="text">
          Only registered commercial passenger vehicles can legally provide commercial passenger
          vehicle services in Queensland. If you want to use your vehicle to provide Taxi vehicle
          services, you must register your vehicle with TMR
        </Typography>
      ) : (
        ''
      )}
      <Typography className="text">Fees and charges apply. </Typography>
      <Typography className="text">
        You must own the vehicle to register it as a commercial passenger vehicle.
      </Typography>
    </div>
    <Divider light />
  </div>
);

// updated
questions.How_do_I_become_a_13cabs_or_Silver_Service_Operator = () => (
  <div className="question">
    <div className="title">How do I become a 13cabs or Silver Service Operator?</div>
    <div className="body">
      <div className="list-title">
        To become a 13cabs or Silver Service Operator, you are required to sign a Network Licence
        Agreement. This agreement:
      </div>
      <ul>
        <li className="list-item">
          allows you to have a payment account with 13cabs/Silver Service
        </li>
        <li className="list-item">requires you to pay a fixed monthly network fee</li>
        <li className="list-item">
          allows 13cabs to rent out and install our dispatch equipment - security cameras, meter,
          dispatch screen, electronic payments terminal, GPS tracking system, dome light and decals
        </li>
        <li className="list-item">
          allows your Taxi to receive booked jobs through the 13cabs dispatch system
        </li>
      </ul>
      <div className="list-title">You are also required to:</div>
      <ul>
        <li className="list-item">supply official documents (eg, driver licence)</li>
        {inStates(['nsw']) ? '' : <li className="list-item">pay a security bond</li>}
        <li className="list-item">ensure your vehicle meets the network’s requirements</li>
      </ul>
      <Typography className="text">
        Completing the steps in the 13cabs Operator application will start you on your way to
        obtaining a Network Licence Agreement.
      </Typography>
    </div>
    <Divider light />
  </div>
);

// updated
questions.How_do_I_become_a_13cabs_Operator = () => (
  <div className="question">
    <div className="title">How do I become a 13cabs Operator?</div>
    <div className="body">
      <div className="list-title">
        To become a 13cabs Operator, you are required to sign a Network Licence Agreement. This
        agreement:
      </div>
      <ul>
        <li className="list-item">allows you to have a payment account with 13cabs</li>
        <li className="list-item">requires you to pay a fixed monthly network fee</li>
        <li className="list-item">
          allows 13cabs to rent out and install our dispatch equipment - security cameras, meter,
          dispatch screen, electronic payments terminal, GPS tracking system, dome light and decals
        </li>
        <li className="list-item">
          allows your Taxi to receive booked jobs through the 13cabs dispatch system
        </li>
      </ul>
      <div className="list-title">You are also required to:</div>
      <ul>
        <li className="list-item">supply official documents (eg, driver licence)</li>
        <li className="list-item">pay a security bond</li>
        <li className="list-item">ensure your vehicle meets the network’s requirements</li>
      </ul>
      <Typography className="text">
        Completing the steps in the 13cabs Operator application will start you on your way to
        obtaining a Network Licence Agreement.
      </Typography>
    </div>
    <Divider light />
  </div>
);

questions.How_do_I_become_a_13limo_Operator = () => (
  <div className="question">
    <div className="title">How do I become a 13limo Operator?</div>
    <div className="body">
      <div className="list-title">
        To become a 13limo Operator, you are required to sign a Network Licence Agreement. This
        agreement:
      </div>
      <ul>
        <li className="list-item">
          allows you to have a payment account with 13cabs/Silver Service
        </li>
        <li className="list-item">requires you to pay a fixed monthly network fee</li>
        <li className="list-item">
          allows 13cabs to rent out and install our dispatch equipment - security cameras, meter,
          dispatch screen, electronic payments terminal, GPS tracking system, dome light and decals
        </li>
        <li className="list-item">
          allows your Taxi to receive booked jobs though the 13cabs dispatch system
        </li>
        <li className="list-item">does not allow your Taxi to conduct hail or Taxi zone work</li>
      </ul>
      <div className="list-title">You are also required to:</div>
      <ul>
        <li className="list-item">supply official documents (eg, driver licence)</li>
        <li className="list-item">pay a security bond</li>
        <li className="list-item">ensure your vehicle meets the network’s requirements</li>
      </ul>
      <Typography className="text">
        Completing the steps in the 13cabs Operator application will start you on your way to
        obtaining a Network Licence Agreement.
      </Typography>
    </div>
    <Divider light />
  </div>
);

questions.How_do_I_become_a_13cabs_or_13limo_Professional_Driver = () => (
  <div className="question">
    <div className="title">How do I become a 13cabs or 13limo Professional Driver?</div>
    <div className="body">
      <Typography className="text">
        To become a Professional Driver, email us at{' '}
        <a href="mailto:join@13cabs.com.au">join@13cabs.com.au</a> or call 1800 546 687.
      </Typography>
    </div>
    <Divider light />
  </div>
);

// updated
questions.How_do_I_become_a_13cabs_Silver_Service_Professional_Driver = () => (
  <div className="question">
    <div className="title">How do I become a 13cabs or Silver Service Professional Driver?</div>
    <div className="body">
      <Typography className="text">
        To become a Professional Driver, email us at{' '}
        <a href="mailto:join@13cabs.com.au">join@13cabs.com.au</a> or call 1800 546 687.
      </Typography>
    </div>
    <Divider light />
  </div>
);

// updated
questions.Can_I_buy_a_vehicle_through_13cabs = () => (
  <div className="question">
    <div className="title">Can I buy a vehicle through 13cabs?</div>
    <div className="body">
      {inStates(['vic']) ? (
        <Typography className="text">
          You can buy a vehicle through 13cabs. A deposit is required to secure your vehicle until
          you obtain an ATR (Authority to Register) from CPVV or have your loan approved.
        </Typography>
      ) : (
        <Typography className="text">
          You can buy a vehicle through 13cabs. A deposit is required to secure your vehicle until
          your payment is made in full.
        </Typography>
      )}
    </div>
    <Divider light />
  </div>
);

// updated
questions.Can_I_finance_my_vehicle_through_13cabs = () => (
  <div className="question">
    <div className="title">Can I finance my vehicle through 13cabs?</div>
    <div className="body">
      {inStates(['nsw']) ? (
        <Typography className="text">
          13cabs can provide vehicle finance for vehicles you buy through us or with other approved
          vendors. You are required to have a good credit rating and authorise us to run a credit
          check. A minimum deposit is required if you are buying the vehicle through 13cabs.
        </Typography>
      ) : inStates(['vic']) ? (
        <Typography className="text">
          13cabs can provide vehicle finance. You are required to have a good credit rating and
          authorise us to run a credit check. A minimum deposit is required.
        </Typography>
      ) : (
        <Typography className="text">
          13cabs can provide vehicle finance. You are required to have a good credit rating and
          authorise us to run a credit check. A minimum deposit is required
        </Typography>
      )}
    </div>
    <Divider light />
  </div>
);

// updated
questions.What_equipment_do_I_need_to_become_a_13cabs_Operator = () => (
  <div className="question">
    <div className="title">What equipment do I need to become a 13cabs Operator?</div>
    <div className="body">
      <div className="list-title">All 13cabs vehicles are required to have:</div>
      <ul>
        <li className="list-item">FAREWAYplus fare calculation device</li>
        <li className="list-item">Cabcharge payments terminal</li>
        <li className="list-item">MTI dispatch system and GPS tracking</li>
        <li className="list-item">internal and external security camera</li>
        <li className="list-item">dome light</li>
        {inStates(['nsw', 'wa']) ? (
          <li className="list-item">13cabs/Silver Service livery</li>
        ) : (
          <li className="list-item">13cabs livery</li>
        )}
      </ul>
      {!inStates(['sa', 'wa']) ? (
        <>
          <Typography className="text">
            If your vehicle already has suitable internal and external security cameras, you are
            welcome to keep them but 13cabs will not maintain them.
          </Typography>
          <Typography className="text">
            If you don’t have your own cameras or would like 13cabs to maintain and upgrade your
            camera systems, 13cabs-i cameras are available to rent for a low monthly fee.
          </Typography>
        </>
      ) : (
        ''
      )}
      <div className="list-title">All 13cabs vehicles have the option to install:</div>
      <ul>
        <li className="list-item">
          <a href="https://spotto.com.au/" target="_blank" rel="noopener noreferrer">
            Spotto
          </a>{' '}
          payments terminal
        </li>
        {inStates(['nsw', 'vic', 'qld']) ? (
          ''
        ) : (
          <li className="list-item">external security cameras</li>
        )}
      </ul>
    </div>
    <Divider light />
  </div>
);

// updated
questions.What_vehicles_are_accepted_into_each_fleet = () => (
  <div className="question">
    <div className="title">What vehicles are accepted into each fleet?</div>
    <div className="body">
      <Typography className="text">
        13cabs and Silver Service each have different vehicle requirements.
      </Typography>
      <div className="list-title">
        Here are the requirements for sedans, wagons and SUVs with each brand:
      </div>
      {inStates(['nt']) ? (
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Silver Service</th>
              <th>13cabs</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="first-column">Vehicle type</td>
              <td>Top of the range sedans and onwards</td>
              <td>Any car</td>
            </tr>
            <tr>
              <td className="first-column">Vehicle colour</td>
              <td>Silver only*</td>
              <td>Any colour</td>
            </tr>
            <tr>
              <td className="first-column">Vehicle age</td>
              <td>No older than 8 years</td>
              <td>No older than 9 years</td>
            </tr>
            <tr>
              <td className="first-column">Inspection requirements</td>
              <td>An initial inspection is required before joining,followed by inspection in accordance with the frequency table below</td>
              <td>An initial inspection is required before joining,followed by inspection in accordance with the frequency table below</td>
            </tr>
            <tr>
              <td className="first-column">Operator</td>
              <td>Licenced</td>
              <td>Licenced</td>
            </tr>
            <tr>
              <td className="first-column">Driver</td>
              <td>13cabs registered with Silver Service accreditation</td>
              <td>13cabs registered</td>
            </tr>
          </tbody>
        </table>
      ) : (
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Silver Service</th>
              <th>13cabs</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="first-column">Vehicle type</td>
              <td>Top of the range sedans and onwards</td>
              <td>Any car</td>
            </tr>
            <tr>
              <td className="first-column">Vehicle colour</td>
              <td>Any colour</td>
              <td>Any colour</td>
            </tr>
            <tr>
              <td className="first-column">Vehicle age</td>
              <td>No older than 8 years</td>
              <td>No older than 10 years</td>
            </tr>
            <tr>
              <td className="first-column">Inspection requirements</td>
              <td>An initial inspection is required before joining,followed by inspection in accordance with the frequency table below</td>
              <td>An initial inspection is required before joining,followed by inspection in accordance with the frequency table below</td>
            </tr>
            <tr>
              <td className="first-column">Operator</td>
              <td>Licenced - ATR</td>
              <td>Licenced - ATR</td>
            </tr>
            <tr>
              <td className="first-column">Driver</td>
              <td>13cabs registered with Silver Service accreditation</td>
              <td>13cabs registered </td>
            </tr>
          </tbody>
        </table>
      )}
      {inStates(['nsw']) ? (
        <div>
          * Silver Service vehicle type to be approved by TAXITECH – please contact
          TAXITECH before purchasing your vehicle
        </div>
      ) : ('')}{' '}
      <br />
      <div className="list-title">
        Here are the requirements for wheelchair accessible Taxis with each brand:
      </div>
      {inStates(['sa', 'vic', 'nt', 'qld', 'wa']) ? (
        <table>
          <thead>
            <tr>
              <th></th>
              <th>13cabs</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="first-column">Vehicle type</td>
              <td>Specific van*</td>
            </tr>
            <tr>
              <td className="first-column">Vehicle colour</td>
              <td>Any colour</td>
            </tr>
            <tr>
              <td className="first-column">Vehicle age</td>
              <td>No older than 12 years</td>
            </tr>

            {inStates(['qld']) ? (
              <tr>
                <td className="first-column">Condition</td>
                <td>Inspection required by TAXITECH</td>
              </tr>
            ) : null}
            <tr>
              <td className="first-column">Inspection requirements</td>
              <td>An initial inspection is required before joining,followed by inspection in accordance with the frequency table below</td>
            </tr>
            <tr>
              <td className="first-column">Operator</td>
              <td>WAT licenced</td>
            </tr>
            <tr>
              <td className="first-column">Driver</td>
              <td>13cabs registered</td>
            </tr>
          </tbody>
        </table>
      ) : (
        <table>
          <thead>
            <tr>
              <th></th>
              <th>13cabs</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="first-column">Vehicle type</td>
              <td>Specific van*</td>
            </tr>
            <tr>
              <td className="first-column">Vehicle colour</td>
              <td>Any colour</td>
            </tr>
            <tr>
              <td className="first-column">Vehicle age</td>
              <td>No older than 12 years</td>
            </tr>
            <tr>
              <td className="first-column">Condition</td>
              <td>Inspection required by TAXITECH</td>
            </tr>
            <tr>
              <td className="first-column">Inspection requirements</td>
              <td>An initial inspection is required before joining,followed by inspection in accordance with the frequency table below</td>
            </tr>
            <tr>
              <td className="first-column">Operator</td>
              <td>WAT licenced</td>
            </tr>
            <tr>
              <td className="first-column">Driver</td>
              {inStates(['wa']) ? (
                <td>13cabs registered</td>
              ) : (
                <td>13cabs registered and WAT accredited</td>
              )}
            </tr>
          </tbody>
        </table>
      )}
      <div>* please contact TAXITECH before purchasing your vehicle</div> <br />
    </div>
    <Divider light />
  </div>
);

// updated
questions.Who_can_have_access_to_13cabs_account_bookings = () => (
  <div className="question">
    <div className="title">Who can have access to 13cabs account bookings?</div>
    <div className="body">
      <Typography className="text">
        13cabs Professional Drivers who have completed additional training can receive account
        bookings.
      </Typography>
    </div>
    <Divider light />
  </div>
);

// updated
questions.I_have_a_different_question = () => (
  <div className="question">
    <div className="title">I have a different question.</div>
    <div className="body">
      <Typography className="text">
        For more information on becoming a 13cabs or Silver Service Operator, please email us at{' '}
        <a href="mailto:partner.growth@13cabs.com.au">partner.growth@13cabs.com.auu</a> or call 1300-069-526.
      </Typography>
    </div>
    <Divider light />
  </div>
);

questions.What_other_pathways_are_available_to_become_a_13cabs_Operator = () => (
  <div className="question">
    <div className="title">What other pathways are available to become a 13cabs Operator?</div>
    <div className="body">
      <Typography className="text">
        Our Tiger Taxis program offers a 12 month pathway to becoming a 13cabs Operator. For more
        information, please email us at <a href="mailto:join@13cabs.com.au">join@13cabs.com.au</a>{' '}
        or call 1800 546 687.
      </Typography>
    </div>
    <Divider light />
  </div>
);

// updated
questions.Can_I_insure_my_vehicle_through_13cabs = () => (
  <div className="question">
    <div className="title">Can I insure my vehicle through 13cabs?</div>
    <div className="body">
      <Typography className="text">13cabs can provide insurance for your vehicles.</Typography>
    </div>
    <Divider light />
  </div>
);

// added
questions.How_do_I_obtain_an_ABN = () => (
  <div className="question">
    <div className="title">How do I obtain an ABN?</div>
    <div className="body">
      <Typography className="text">
        You must apply for an ABN through the{' '}
        <a
          href="https://www.abr.gov.au/business-super-funds-charities/applying-abn"
          target="_blank"
          rel="noopener noreferrer">
          Australian Business Register
        </a>
      </Typography>
    </div>
    <Divider light />
  </div>
);

questions.How_do_I_become_a_Silver_Service_Professional_Driver = () => (
  <div className="question">
    <div className="title">How do I become a Silver Service Professional Driver?</div>
    <div className="body">
      <Typography className="text">
        To become a Professional Driver, email us at{' '}
        <a href="mailto:drivertraining@13cabs.com.au">drivertraining@13cabs.com.au</a>.
      </Typography>
    </div>
    <Divider light />
  </div>
);

questions.How_do_I_become_a_13cabs_Professional_Driver = () => (
  <div className="question">
    <div className="title">How do I become a 13cabs Professional Driver?</div>
    <div className="body">
      <Typography className="text">
        To become a Professional Driver, email us at{' '}
        <a href="mailto:join@13cabs.com.au">join@13cabs.com.au</a> or call 1800 546 687.
      </Typography>
    </div>
    <Divider light />
  </div>
);

questions.Can_I_lease_a_taxi_plate_through_13cabs = () => (
  <div className="question">
    <div className="title">Can I lease a taxi plate through 13cabs?</div>
    <div className="body">
      <Typography className="text">13cabs can lease you a taxi plate.</Typography>
    </div>
    <Divider light />
  </div>
);

questions.What_do_I_need_to_do_before_becoming_a_13cabs_Operator = () => (
  <div className="question">
    <div className="title">What do I need to do before becoming a 13cabs Operator?</div>
    <div className="body">
      <Typography className="text">
        To become a 13cabs Operator in SA you must first obtain Operator accreditation through TCSA
        and DIT.
      </Typography>
      <Typography className="text">Fees and charges apply.</Typography>
    </div>
    <Divider light />
  </div>
);

questions.How_do_I_become_a_13cabs_Professional_Driver = () => (
  <div className="question">
    <div className="title">How do I become a 13cabs Professional Driver?</div>
    <div className="body">
      <Typography className="text">
        To become a Professional Driver, email us at{' '}
        <a href="mailto:join@13cabs.com.au">join@13cabs.com.au</a> or call 1800 546 687.
      </Typography>
    </div>
    <Divider light />
  </div>
);

questions.Can_I_buy_a_vehicle_through_13cabs_sa = () => (
  <div className="question">
    <div className="title">Can I buy a vehicle through 13cabs?</div>
    <div className="body">
      <Typography className="text">
        You cannot buy a vehicle through 13cabs in South Australia.
      </Typography>
    </div>
    <Divider light />
  </div>
);

questions.Can_I_finance_my_vehicle_through_13cabs_sa = () => (
  <div className="question">
    <div className="title">Can I finance my vehicle through 13cabs?</div>
    <div className="body">
      <Typography className="text">
        13cabs cannot provide vehicle finance in South Australia.
      </Typography>
    </div>

    <Divider light />
  </div>
);

questions.What_vehicles_are_accepted_into_the_13cabs_fleet = () => (
  <div className="question">
    <div className="title">What vehicles are accepted into the 13cabs fleet?</div>
    <div className="list-title">Here are the requirements for 13cabs sedans, wagons and SUVs:</div>
    <table>
      <thead>
        <tr>
          <th></th>
          <th>13cabs</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="first-column">Vehicle type</td>
          <td>Any car</td>
        </tr>
        <tr>
          <td className="first-column">Vehicle colour</td>
          <td>White</td>
        </tr>
        {inStates(['sa']) ? (
          <tr>
            <td className="first-column">Vehicle age</td>
            <td>No older than 7 years</td>
          </tr>
        ) : (
          <tr>
            <td className="first-column">No older than 7 years</td>
            <td>Item</td>
          </tr>
        )}
        <tr>
          <td className="first-column">Inspection requirements</td>
          {inStates(['sa']) ? (
            <td>One before joining the fleet then every 4 months</td>
          ) : (
            <td>Inspection required by TAXITECH</td>
          )}
        </tr>
        <tr>
          <td className="first-column">Operator</td>
          <td>Licenced - ATR</td>
        </tr>
        <tr>
          <td className="first-column">Driver</td>
          <td>13cabs registered</td>
        </tr>
      </tbody>
    </table>
    <br />
    <div className="list-title">Here are the requirements for wheelchair accessible Taxis:</div>
    <table>
      <thead>
        <tr>
          <th></th>
          <th>13cabs</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="first-column">Vehicle type</td>
          <td>ASpecific van*</td>
        </tr>
        <tr>
          <td className="first-column">Vehicle colour</td>
          <td>White</td>
        </tr>
        {inStates(['sa']) ? (
          <tr>
            <td className="first-column">Vehicle age</td>
            <td>No older than 9 years</td>
          </tr>
        ) : (
          <tr>
            <td className="first-column">No older than 7 years</td>
            <td>Item</td>
          </tr>
        )}
        <tr>
          <td className="first-column">Condition</td>
          <td>Inspection required by TAXITECH</td>
        </tr>
        <tr>
          <td className="first-column">Inspection requirements</td>
          <td>An initial inspection is required before joining,followed by inspection in accordance with the frequency table below</td>
        </tr>
        <tr>
          <td className="first-column">Operator</td>
          <td>WAT licenced</td>
        </tr>
        <tr>
          <td className="first-column">Driver</td>
          <td>13cabs registered</td>
        </tr>
      </tbody>
    </table>
    <div>* please contact TAXITECH before purchasing your vehicle</div> <br />

    <Divider light />
  </div>
);

questions.What_vehicles_inspection_frequency_range_13cabs_fleet = () => (
  <div className="question">
    <div className="title">Updated Inspection Frequency from 1 July 2026</div>
    <div className="body"></div>
  <div className="list-title"></div>
    <table>
      <thead>
        <tr>
          <th>Vehicle age</th>
          <th>Inspection frequency</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="first-column">0-2 years</td>
          <td>1 per year</td>
        </tr>
        <tr>
          <td className="first-column">2-4 years</td>
          <td>2 per year</td>
        </tr>
          <tr>
            <td className="first-column">4-6 years</td>
            <td>3 per year</td>
          </tr>
          <tr>
            <td className="first-column">6-8 years</td>
            <td>4 per year</td>
          </tr>
        <tr>
          <td className="first-column">8-10 years</td>
          <td>6 per year</td>
        </tr>
        <tr>
          <td className="first-column">10+ years</td>
          <td>8 per year</td>
        </tr>
      </tbody>
      
    </table> <div>* From Wednesday 1 July 2026, each inspection will cost $15 + GST</div> <br />
    <Divider light />
  </div>
)

questions.What_do_I_need_to_do_before_becoming_a_13cabs_or_Silver_Service_Operator = () => (
  <div className="question">
    <div className="title">
      What do I need to do before becoming a 13cabs or Silver Service Operator?
    </div>
    <div className="body">
      <Typography className="text">
        Only registered commercial passenger vehicles can legally provide commercial passenger
        vehicle services in Queensland. If you want to use your vehicle to provide Taxi vehicle
        services, you must register your vehicle with TMR.
      </Typography>
      <Typography className="text">Fees and charges apply. </Typography>
      <Typography className="text">
        You must own the vehicle to register it as a commercial passenger vehicle.
      </Typography>
    </div>
    <Divider light />
  </div>
);

questions.template = () => (
  <div className="question">
    <div className="title">Title</div>
    <div className="body">
      <Typography className="text">Text</Typography>
      <div className="list-title">ListTitle</div>
      <ul>
        <li className="list-item">ListItem</li>
      </ul>
    </div>
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Header</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="first-column">firstColumn</td>
          <td>Item</td>
        </tr>
      </tbody>
    </table>
    <Divider light />
  </div>
);

faqs.nsw = () => (
  <div>
    {questions.Why_13cabs()}
    {questions.What_do_I_need_to_do_before_becoming_a_13cabs_silver_service_Operator()}
    {questions.How_do_I_become_a_13cabs_or_Silver_Service_Operator()}    
    {questions.How_do_I_become_a_13cabs_Professional_Driver()}    
    {questions.How_do_I_become_a_Silver_Service_Professional_Driver()}
    {questions.How_do_I_obtain_an_ABN()}
    {questions.Can_I_buy_a_vehicle_through_13cabs()}
    {questions.Can_I_finance_my_vehicle_through_13cabs()}
    {questions.Can_I_insure_my_vehicle_through_13cabs()}
    {questions.Can_I_lease_a_taxi_plate_through_13cabs()}
    {questions.What_equipment_do_I_need_to_become_a_13cabs_Operator()}
    {questions.What_vehicles_are_accepted_into_each_fleet()}
    {questions.What_vehicles_inspection_frequency_range_13cabs_fleet()}
    {questions.Who_can_have_access_to_13cabs_account_bookings()}
    {questions.I_have_a_different_question()}
  </div>
);

faqs.vic = () => (
  <div>
    {questions.Why_13cabs()}
    {questions.What_do_I_need_to_do_before_becoming_a_13cabs_silver_service_Operator()}
    {questions.How_do_I_become_a_13cabs_or_Silver_Service_Operator()}
    {questions.How_do_I_become_a_13cabs_Professional_Driver()}    
    {questions.How_do_I_become_a_Silver_Service_Professional_Driver()}
    {questions.How_do_I_obtain_an_ABN()}
    {questions.Can_I_buy_a_vehicle_through_13cabs()}
    {questions.Can_I_finance_my_vehicle_through_13cabs()}
    {questions.What_equipment_do_I_need_to_become_a_13cabs_Operator()}
    {questions.What_vehicles_are_accepted_into_each_fleet()}
    {questions.What_vehicles_inspection_frequency_range_13cabs_fleet ()}
    {questions.Who_can_have_access_to_13cabs_account_bookings()}
    {questions.I_have_a_different_question()}
  </div>
);

faqs.qld = () => (
  <div>
    {questions.Why_13cabs()}
    {questions.What_do_I_need_to_do_before_becoming_a_13cabs_or_Silver_Service_Operator()}
    {questions.How_do_I_become_a_13cabs_or_Silver_Service_Operator()}
    {questions.How_do_I_obtain_an_ABN()}
    {questions.How_do_I_become_a_13cabs_Professional_Driver()}    
    {questions.How_do_I_become_a_Silver_Service_Professional_Driver()}
    {questions.Can_I_buy_a_vehicle_through_13cabs()}
    {questions.Can_I_finance_my_vehicle_through_13cabs()}
    {questions.What_equipment_do_I_need_to_become_a_13cabs_Operator()}
    {questions.What_vehicles_are_accepted_into_each_fleet()}
    {questions.What_vehicles_inspection_frequency_range_13cabs_fleet()}
    {questions.Who_can_have_access_to_13cabs_account_bookings()}
    {questions.I_have_a_different_question()}
  </div>
);

faqs.sa = () => (
  <div>
    {questions.Why_13cabs()}
    {questions.What_do_I_need_to_do_before_becoming_a_13cabs_Operator()}
    {questions.How_do_I_become_a_13cabs_Operator()}
    {questions.How_do_I_obtain_an_ABN()}
    {questions.How_do_I_become_a_13cabs_Professional_Driver()}
    {questions.Can_I_buy_a_vehicle_through_13cabs_sa()}
    {questions.Can_I_finance_my_vehicle_through_13cabs_sa()}
    {questions.What_equipment_do_I_need_to_become_a_13cabs_Operator()}
    {questions.What_vehicles_are_accepted_into_the_13cabs_fleet()}
    {questions.What_vehicles_inspection_frequency_range_13cabs_fleet()}
    {questions.Who_can_have_access_to_13cabs_account_bookings()}
    {questions.I_have_a_different_question()}
  </div>
);

faqs.wa = () => (
  <div>
    {questions.Why_13cabs()}
    {questions.What_do_I_need_to_do_before_becoming_a_13cabs_silver_service_Operator()}
    {questions.How_do_I_become_a_13cabs_or_Silver_Service_Operator()}
    {questions.How_do_I_become_a_13cabs_Professional_Driver()}    
    {questions.How_do_I_become_a_Silver_Service_Professional_Driver()}
    {questions.How_do_I_obtain_an_ABN()}
    {questions.What_equipment_do_I_need_to_become_a_13cabs_Operator()}
    {questions.What_vehicles_are_accepted_into_each_fleet()}
    {questions.What_vehicles_inspection_frequency_range_13cabs_fleet()}
    {questions.Who_can_have_access_to_13cabs_account_bookings()}
    {questions.I_have_a_different_question()}
  </div>
);

faqs.nt = () => (
  <div>
    {questions.Why_13cabs()}
    {questions.What_do_I_need_to_do_before_becoming_a_13cabs_silver_service_Operator()}
    {questions.How_do_I_become_a_13cabs_or_Silver_Service_Operator()}
    {questions.How_do_I_become_a_13cabs_Professional_Driver()}    
    {questions.How_do_I_become_a_Silver_Service_Professional_Driver()}
    {questions.How_do_I_obtain_an_ABN()}
    {questions.Can_I_buy_a_vehicle_through_13cabs()}
    {questions.Can_I_finance_my_vehicle_through_13cabs()}
    {questions.Can_I_insure_my_vehicle_through_13cabs()}
    {questions.What_equipment_do_I_need_to_become_a_13cabs_Operator()}
    {questions.What_vehicles_are_accepted_into_each_fleet()}
    {questions.What_vehicles_inspection_frequency_range_13cabs_fleet()}
    {questions.Who_can_have_access_to_13cabs_account_bookings()}
    {questions.I_have_a_different_question()}
  </div>
);

const Step2Faq = (props) => {
  currentState = props.state;
  return (
    <Step id="faq" title="FAQ" nextText="Get Started">
      <Button
        variant="contained"
        color="primary"
        style={{ margin: '-10px 0 10px 0' }}
        onClick={() => props.jumpTo('termsandconds')}>
        Get Started
      </Button>
      <Grid container direction="column" alignItems="center">
        <Grid item xs={12} sm={10} md={8}>
          {(typeof faqs[props.state] === 'function' && faqs[props.state](props)) ||
            'Something went wrong'}
        </Grid>
      </Grid>
    </Step>
  );
};
export default Step2Faq;
